import { API_ENDPOINTS } from "../../../Api/apiEndPoints"
import axiosInstance from "../../../Api/axiosInstance"

export const getOutcomes = async (params={})=>{
    let response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_OUTCOMES_LIST,{params:params})
    const rowData = await response?.data;
   const data = Array.isArray(rowData?.data?.data)
   ? rowData.data.data.map((item: any) => {
      return {
        Type: item.Type || "-",
        Reason: item.Reason || "-",
        OutletOutcomeId: item.OutletOutcomeId || "-",
        OutletTypeId: item.OutletTypeId || "-",
      };
    })
   : [];
   
   return {data,rowData};
} 
export const addOutCome = async(ReqBody:any)=>{

    const url  =`${API_ENDPOINTS.CONFIGURATION.POST_ADD_OUTCOME}`
    let response = await axiosInstance.post(url,ReqBody)
}

export const updatOutCome = async(ReqBody:any,id:number)=>{
     const url = `${API_ENDPOINTS.CONFIGURATION.PUT_UPDATE_OUTCOME}/${id}`;
     let response = await axiosInstance.put(url,ReqBody); 
}